function getLanguageLabel(code: string): string {
  const native = new Intl.DisplayNames([code], { type: 'language' }).of(code);
  const english = new Intl.DisplayNames(['en'], { type: 'language' }).of(code);
  if (native && english && native !== english) return `${native} (${english})`;
  return native ?? english ?? code;
}

interface TranslationPillProps {
  targetLanguage: string | null;
  enabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export function TranslationPill({ targetLanguage, enabled, onToggle }: TranslationPillProps) {
  if (!targetLanguage) return null;

  const label = getLanguageLabel(targetLanguage);

  return (
    <button
      onClick={() => onToggle(!enabled)}
      className={`text-xs px-2.5 py-1 rounded-full transition-colors ${
        enabled
          ? 'bg-accent/15 text-accent'
          : 'bg-ink/5 text-ink/30 line-through'
      }`}
    >
      → {label} {enabled ? '✓' : ''}
    </button>
  );
}
